import React, { useState } from 'react';
import { useI18n } from '../../i18n';
import './MultiSelectUsers.css';

const MultiSelectUsers = ({ users, selectedUserIds, onChange, error, loading }) => {
    const { t } = useI18n();
    const [searchTerm, setSearchTerm] = useState('');

    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleToggleUser = (userId) => {
        if (selectedUserIds.includes(userId)) {
            onChange(selectedUserIds.filter(id => id !== userId));
        } else {
            onChange([...selectedUserIds, userId]);
        }
    };

    const handleSelectAll = () => {
        if (selectedUserIds.length === filteredUsers.length) {
            onChange([]);
        } else {
            onChange(filteredUsers.map(user => user.id));
        }
    };

    return (
        <div className="multi-select-users">
            <div className="multi-select-search">
                <input
                    type="text"
                    placeholder={t('pages.teams.form.invite_placeholder')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
            </div>

            <div className="multi-select-actions">
                <button
                    type="button"
                    onClick={handleSelectAll}
                    className="select-all-btn"
                >
                    {selectedUserIds.length === filteredUsers.length && filteredUsers.length > 0
                        ? t('common.actions.deselect_all')
                        : t('common.actions.select_all')}
                </button>
                <span className="selected-count">
                    {t('common.labels.selected_count', { count: selectedUserIds.length })}
                </span>
            </div>

            <div className={`multi-select-list ${error ? 'has-error' : ''}`}>
                {loading ? (
                    <div className="loading-users">{t('common.status.loading')}</div>
                ) : filteredUsers.length === 0 ? (
                    <div className="no-users">
                        {searchTerm ? t('common.empty_states.no_results') : t('pages.teams.no_users_available_invite')}
                    </div>
                ) : (
                    filteredUsers.map(user => (
                        <label key={user.id} className="user-item">
                            <div className='user-item-content'>
                                <input
                                    type="checkbox"
                                    checked={selectedUserIds.includes(user.id)}
                                    onChange={() => handleToggleUser(user.id)}
                                />
                                <div className='msu-user-container'>
                                    <div className="msu-user-avatar">
                                        {user.avatar ? (
                                            <img src={user.avatar} alt={user.name} />
                                        ) : (
                                            <div className="msu-avatar-initials">
                                                {user.name.charAt(0).toUpperCase()}
                                            </div>
                                        )}
                                    </div>
                                    <div className="msu-user-info">
                                        <div className="msu-user-name">{user.name}</div>
                                        <div className="msu-user-email">{user.email}</div>
                                    </div>
                                </div>
                                <div className="checkmark">
                                    <svg viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                        </label>
                    ))
                )}
            </div>

            {error && <div className="multi-select-error">{error}</div>}
        </div>
    );
};

export default MultiSelectUsers;
